<div class="mb-3">
  <label *ngIf="hasLabel" class="form-label">{{ label | translate }}</label>
  <textarea
    class="form-control"
    [class.is-invalid]="showError"
    [formControl]="field"
    [placeholder]="placeholder | translate"
    [required]="required"
    [disabled]="disabled"
    [attr.id]="resolvedInputId"
  ></textarea>
  <div *ngIf="hasHint" class="form-text">{{ hint | translate }}</div>
  <div *ngIf="isPending" class="form-text">{{ 'label.pending' | translate }}</div>
  <div *ngIf="showError" class="form-text text-danger">{{ error | translate }}</div>
</div>
